import { intervalToDuration } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * How long ago a reading was drawn, at the coarsest unit that still says something: days inside a
 * month, months inside a year, then years and months ("1y 11m"). A chart age is read for "is this
 * still current?", so the finer units are noise once the coarser one is non-zero.
 */
export const useLabResultAgeLabel = (): ((date: Date, now: Date) => string) => {
  const { t } = useTranslation('records');

  return useCallback(
    (date: Date, now: Date): string => {
      if (date.getTime() > now.getTime()) return t('labAgeToday');
      const { years = 0, months = 0, days = 0 } = intervalToDuration({ start: date, end: now });
      if (years > 0) {
        return months > 0 ? t('labAgeYearsMonths', { years, months }) : t('labAgeYears', { count: years });
      }
      if (months > 0) return t('labAgeMonths', { count: months });
      if (days > 0) return t('labAgeDays', { count: days });
      return t('labAgeToday');
    },
    [t],
  );
};
